<template>
  <!-- TODO: wrapper on route with navigation etc. -->
  <!-- Only render dialog when needed -->
  <Dialog
    v-model:visible="visible"
    modal
    dismissableMask
    :breakpoints="{ '960px': '90vw', '640px': '95vw' }"
    :style="{ width: '70vw', maxWidth: '1200px' }"
    @hide="onHide"
  >
    <!-- Pass current props to consumer via scoped slot -->
    <slot :state="state" />
  </Dialog>
</template>

<script setup lang="ts">
import { reactive, ref } from 'vue';
import { type RouteLocationRaw, useRouter } from 'vue-router';

type Params = Record<string, unknown>;

type OpenInModalPayload = {
  uuid: string; // required
  [key: string]: unknown;
};

export type ModalOrPageExpose = {
  openInModal: (p: OpenInModalPayload) => void; // open modal with payload
  openOnPage: (to: import('vue-router').RouteLocationRaw) => void; // navigate
};

/** Internal state for the modal content */
const state = reactive<{
  uuid: string | null;
  inModal: boolean;
  params: Params; // <— collect arbitrary keys here
}>({
  uuid: null,
  inModal: false,
  params: {},
});

const visible = ref(false);
const router = useRouter();

/** Open given content inside the modal */
function openInModal(payload: OpenInModalPayload) {
  const { uuid, ...rest } = payload;

  if (!uuid) {
    return;
  }

  state.uuid = uuid;
  state.params = rest;
  state.inModal = true;
  visible.value = true;
}

/** Navigate to a route instead of opening a modal */
function openOnPage(to: RouteLocationRaw) {
  // Push route directly
  void router.push(to);
}

/** Optional: when dialog hides, clean state */
function onHide() {
  // Clean up to avoid stale props
  state.uuid = null;
  state.params = {};
}

/** Expose an imperative API for the parent */
defineExpose({
  openInModal,
  openOnPage,
});
</script>
